import { DEFAULT_VALUES } from 'Constants/WidgetConfig';
import { isInvalidOccupancy, sanitizeOccupancy } from 'Shared/utils/OccupancyHelper';

const initialState = {
    isLoading : false,
    data      : null,
    error     : false,
    dataSet   : false,
};

const processDataRequestSuccess = (state, action) => {
    const {
        minOccupancy, maxOccupancy, childrenEnabled, minChildAge, maxChildAge, defaultOccupancy,
    } = action.payload.settings;

    const processDefaultOccupancy = () => {
        const finalOccupancy = defaultOccupancy?.length ? defaultOccupancy : [ DEFAULT_VALUES.defaultOccupancy ];

        const checkingParams = { childrenEnabled, minOccupancy, maxOccupancy, minChildAge, maxChildAge };

        if (isInvalidOccupancy(finalOccupancy, checkingParams)) {
            return sanitizeOccupancy(finalOccupancy, checkingParams);
        }
        return finalOccupancy;
    };

    const customizations = action.payload.customizations || {};

    const result = {
        customizations,
        ...state.data,
        ...action.payload.settings,
    };

    return {
        ...result,
        defaultOccupancy: processDefaultOccupancy(),
    };
};

const settings = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'DATA_REQUEST_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'DATA_REQUEST_SUCCESS':
            return {
                isLoading : false,
                data      : processDataRequestSuccess(state, action),
                error     : false,
                dataSet   : true,
            };
        case 'DATA_REPLACEMENT':
            return {
                dataSet   : !!state?.dataSet,
                isLoading : !!state?.isLoading,
                error     : false,
                data      : {
                    ...state.data,
                    [action.payload.key]: action.payload.value,
                },
            };
        case 'DATA_REQUEST_FAILURE':
            return {
                ...state,
                isLoading : false,
                data      : { ...state.data, errorInformation: action.payload },
                error     : true,
            };
        case 'CHANGE_LANGUAGE':
            return {
                ...state,
                isLoading : false,
                data      : { ...state.data, language: action.payload },
                error     : false,
            };
        default:
            return state;
    }
};

export default settings;
